import React, { Component } from 'react';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { Link } from 'react-router-dom';
import Icon from '@material-ui/core/Icon';
import { withRouter } from 'react-router-dom';
import './Sidebar.css';
import { ReactComponent as Base58Logo } from '../../../assets/svg/Base58-logo.svg';
import { getSidebarItems } from './SidebarUtil';
import { withTranslation } from 'react-i18next';
import PerfectScrollbar from 'react-perfect-scrollbar'
import packageJson from '../../../../package.json'
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";
import Collapse from "@material-ui/core/Collapse";

class Sidebar extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: []
        }
    }

    componentDidMount() {
        this.setState({ items: getSidebarItems() })

    }

    handleClickItem = (parentIndex) => {
        localStorage.setItem("sidebarCollapseIndex", parentIndex)
        if (this.props.mobileOpen) {
            this.props.handleDrawerToggle();
        }
    };

    handleClickItemWithChilds = (index) => {
        let { items } = this.state;
        items[index].opened = !items[index].opened;
        this.setState({ items: items });
    };

    render() {

        const drawer = (
            <div>
                <div style={{ textAlign: 'center', height: 64, padding: 10, cursor: 'pointer' }} onClick={() => this.props.history.push("/home")}>
                    <Base58Logo />
                </div>
                <Divider style={{ backgroundColor: 'white' }} />
                <List disablePadding>
                    <PerfectScrollbar style={{ height: 'calc(100vh - 70px)' }}>
                        {this.state.items.map((item, parentIndex) => {
                            return <React.Fragment key={parentIndex}>
                                <ListItem
                                    classes={{ selected: "sidebar-item-selected" }}
                                    className={this.props.location.pathname.includes(item.link) ? "sidebar-item-selected" : "sidebar-item-not-selected"}
                                    selected={this.props.location.pathname.includes(item.link)}
                                    button
                                    key={"parent-" + parentIndex}
                                    onClick={() => this.handleClickItem(parentIndex)}
                                    component={Link}
                                    to={item.link}>
                                    <Icon style={{
                                        marginRight: 18,
                                        width: '35px'
                                    }}>{item.icon}</Icon>
                                    <ListItemText primary={this.props.t(item.title)} />
                                    {item.children ? parentIndex === Number(localStorage.getItem("sidebarCollapseIndex")) ? <ExpandLess /> : <ExpandMore /> : null}
                                </ListItem>
                                {Array.isArray(item.children) ? (
                                    <Collapse in={parentIndex === Number(localStorage.getItem("sidebarCollapseIndex")) ? true : false} timeout="auto" unmountOnExit>
                                        <List disablePadding>
                                            {item.children.map((subItem, index) => {
                                                return <ListItem
                                                    classes={{ selected: "sidebar-item-selected" }}
                                                    className={this.props.location.pathname.includes(subItem.link) ? "sidebar-item-selected" : "sidebar-item-not-selected"}
                                                    selected={this.props.location.pathname.includes(subItem.link)}
                                                    button
                                                    key={"children-" + index}
                                                    component={Link}
                                                    to={subItem.link}>
                                                    <Icon style={{
                                                        paddingLeft: 15, marginRight: 18, width: '35px'
                                                    }}>{subItem.icon}</Icon>
                                                    <ListItemText primary={this.props.t(subItem.title)} />
                                                </ListItem>
                                            })}
                                        </List>
                                    </Collapse>
                                ) : null}
                            </React.Fragment>
                        })}
                    </PerfectScrollbar>
                </List>
                <div style={{ position: 'absolute', textAlign: 'center', bottom: 20, width: '100%' }}>
                    v{packageJson.version || 'NOT_SET'}
                </div>
            </div >
        );

        const container = window !== undefined ? () => window.document.body : undefined;

        return (
            <nav className="drawer" aria-label="mailbox folders">
                {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
                <Hidden smUp implementation="css">
                    <Drawer
                        container={container}
                        variant="temporary"
                        anchor="left"
                        open={this.props.mobileOpen}
                        onClose={this.props.handleDrawerToggle}
                        classes={{
                            paper: "drawerPaper",
                        }}
                        ModalProps={{
                            keepMounted: true, // Better open performance on mobile.
                        }}
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
                <Hidden smDown implementation="css">
                    <Drawer
                        classes={{
                            paper: "drawerPaper",
                        }}
                        variant="permanent"
                        open
                    >
                        {drawer}
                    </Drawer>
                </Hidden>
            </nav>
        );
    }
}

export default withRouter(withTranslation()(Sidebar));
